import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const NoSQLAndCAP = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Introduction to NoSQL and CAP Theorem"
    videos={[
      "https://www.youtube.com/embed/BHqjEjzAicA?si=UWeAG9iz9Ts8QdiJ",
      "https://www.youtube.com/embed/mMdZEAKtntA?si=nmUkmbffPpVIHxsT"
    ]}
    takeaways={[]}
    questions={[
      "1) Given a large-scale e-commerce application that requires high availability, low latency, and the ability to handle massive amounts of transactional data, which NoSQL database types would be most suitable? Justify your answer with specific scenarios to illustrate the key considerations. Discuss why other NoSQL types might not be suitable.",
      "2) Give a comparative study of NoSQL and Relational Database",
      "3) Explain the CAP theorem and its implications for distributed system databases. Analyze how the CAP theorem influences the database design choices of an online shopping platform, focusing on the trade-offs between consistency, availability, and partition tolerance.",
      "4) Explain the four types of NOSQL database model and suggest the application of each model.",
      "5) Consider an e-commerce website with a global presence. Some of the key areas for data management are maintaining user sessions, secured and reliable financial data management, shopping cart management, recommendation of products, maintaining product catalog, generating reports, performing analytics, and logging user activities. For the above scenario, choose the appropriate database and justify in terms of CAP theorem and BASE properties.",
      "6) Which of the four NoSQL database types is more suitable for storing session details? Justify by explaining the features of the database chosen."
    ]}
    exampleVideos={[]}
  />
);
}

export default NoSQLAndCAP;
